export const baseURL = "https://roulettecasino.ajobfun.store/";
export const adminBaseURL = "https://admin.ajobfun.store/";
export const key = "BS67Rfb0Tf";
